import { Component, OnInit } from '@angular/core';
import { Product } from '../../../../classes/Product';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';
import { GlobalService } from '../../../services/global.service';
import { WindowRef } from '../../../../classes/windowRef';
import {ImagesService} from '../../../services/images.service';
import * as $ from 'jquery';
import swal from 'sweetalert2';

@Component({
  host: {
      '( document: scroll )': 'onScrollDocument( $event )'
  },
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {

  productsData: Product[] = [];
  contentVisible: boolean = false;

  availableRoles: string[] = [ 'admin', 'sales', 'manager' ];
  isAvailable: boolean = true;

  isChangeActivityButtonDisabled: boolean = true;
  isActivePopupVisible: boolean = false;

  entities = {
    bulb: 'Lamp',
    fixture: 'Fixture',
    accessory: 'Accessory',
    housing: 'Housing'
  };

  exPr = {
    existing: "Existing",
    proposed: "Proposed"
  };

  paginationData = {
    count: 100,
    offset: 0,
    count_all: 0,
    max_product_count: 0,
    currentPage: 1,
    maxPage: 1
  };

  emptyFilters: boolean = true;

  productsActivities = {};

  src: string = "/dist/assets/picture-not-available.jpg";

  linkImage = {
    attachment: '',
    attachment_public_id: ''
  };

  _scrollTop:number = 0;
  _scrollTopTimer:any = null;
  _scrollSystemInit: boolean = false;


  selectAllCH: boolean = false;

  // Filters data

  filters = {
    existingOrProposed: 'proposed',
    entity: '',
    manufacturer: '',
    productType: '',
    baseType: '',
    SKU: '',
    description: ''
  };

  filtersDropdowns = {
    baseType: [],
    manufacturer: [],
    existingOrProposed: [],
    entity: [],
    productType: []
  };

  filtersTimeout: any = {};

  type_of_products:string = 'products';

  create_existing: boolean = false;

  acceptCloneProduct: boolean = false;
  cloneProductPopupVisible: boolean = false;
  cloneProductID: number = 0;


  popupMinimized: boolean = false;


  selectParams: any = {

    existingOrProposed: {
      id: 'inputExistingOrProposed',
      change: ( event ) => { 
        this.filters.existingOrProposed = event.value; 
        this.updateData( );
      },
      options: [ { text: '', value: '' } ]
    },

    entity: {
      id: 'inputEntity',
      change: ( event ) => { 
        this.filters.entity = event.value; 
        this.updateData( );
      },
      options: [ 
        { text: '', value: '' },
        { text: 'Lamp', value: 'bulb' },
        { text: 'Fixture', value: 'fixture' },
        { text: 'Accessory', value: 'accessory' },
        { text: 'Housing', value: 'housing' } 
      ]
    },

    manufacturer: {
      id: 'inputManufacturer',
      change: ( event ) => { 
        this.filters.manufacturer = event.value; 
        this.updateData( );
      },
      options: [ { text: '', value: '' } ]
    },

    productType: {
      id: 'inputProductType',
      change: ( event ) => { 
        this.filters.productType = event.value; 
        this.updateData( );
      },
      options: [ { text: '', value: '' } ]
    },

    baseType: {
      id: 'inputBaseType',
      isDisabled: this.filters.entity == 'accessory',
      change: ( event ) => { 
        this.filters.baseType = event.value; 
        this.updateData( );
      },
      options: [ { text: '', value: '' } ]
    }

  }

  constructor ( 
    private model: ModelService,
    private winRef: WindowRef,
    private global: GlobalService,
    private cropper: ImagesService,
    private loginService: LoginService ) {
    this.global.setDocumentTitle( 'Products' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;

    let _acceptCloneProduct = 'false';
    _acceptCloneProduct = localStorage.getItem('acceptCloneProduct');
    this.acceptCloneProduct = false;
    if (_acceptCloneProduct) {
      if (_acceptCloneProduct == 'true') {
        this.acceptCloneProduct = true;
      } 
    }

  }

  ngOnInit ( ) {
    let _pagination = localStorage.getItem( 'paginationProductsList' );
    let _filters = localStorage.getItem( 'filtersProductsList' );
    if ( _pagination ) this.paginationData = JSON.parse( _pagination );
    if ( _filters ) this.filters = JSON.parse( _filters );
    if ( !this.filters.SKU ) this.filters.SKU = '';

    this.global.setProductRefPage( '/products-list' );
  }

  ngAfterViewInit ( ) {
    let _scroll = localStorage.getItem( 'scrollProductsList' );
    if ( _scroll ) this._scrollTop = +_scroll;
    this.loadData( this._scrollIntoView( ) );
  }

  openProduct(productID) {
    this.global.redirect('/product-detail/'+productID);
  }

  exportProductCSV ( ) {
    this.model.exportProductCSV( ( response ) => {
      if ( response.answer == 'success' ) {

          let data = {
            type: 'success',
            title: 'Success',
            html: 'Products have been extracted into the CSV file: <a href="'+response.info.csv_link+'" download="'+response.info.filename+'" onClick="swal.close();">Download CSV</a>',
            showConfirmButton: false
          };
          this.global.successMessage( data );
      }
    });
  }

  changePage ( page ) {
    this.paginationData.currentPage = page;
    this.paginationData.offset = (page-1) * this.paginationData.count;
    this.loadData( );
    $('html,body').animate({ scrollTop: 0 }, 'slow');
    localStorage.setItem( 'paginationProductsList', JSON.stringify( this.paginationData ) );
  }

  loadData ( cb?, withoutPreloader? ) {

    let _withoutPreloader = false;
    if ( withoutPreloader ) _withoutPreloader = true;
    
    this.productsActivities = {};
    this.emptyFilters = true;
    this.create_existing = false;
    this.type_of_products = 'products';
    if ( this.filters.existingOrProposed != '' || this.filters.entity != '' || this.filters.manufacturer != '' || this.filters.productType != '' || this.filters.baseType != '' ) this.emptyFilters = false;
    if ( this.filters.entity != '' ) {
      if ( this.filters.entity == 'bulb' ) this.type_of_products = 'lamps';
      if ( this.filters.entity == 'fixture' ) this.type_of_products = 'fixtures';
      if ( this.filters.entity == 'housing' ) this.type_of_products = 'housings';
      if ( this.filters.entity == 'accessory' ) this.type_of_products = 'accessories';
    }
    // this.contentVisible = false;
    this.model.getProductsData( ( prData, paginationData, dropdowns, create_existing ) => {
      this.contentVisible = true;
      this.productsData = prData;
      this.paginationData = paginationData;
      this.filtersDropdowns = dropdowns;
      this.create_existing = create_existing;

      let _exProp = [];
      let _ent = [];
      let i;
      this.selectParams.existingOrProposed.options = [{ value: '', text: 'All' }];
      this.selectParams.entity.options = [{ value: '', text: 'All' }];
      this.selectParams.productType.options = [{ value: '', text: 'All' }];
      this.selectParams.baseType.options = [{ value: '', text: 'All' }];
      this.selectParams.manufacturer.options = [{ value: '', text: 'All' }];
      for ( i = 0; i < this.filtersDropdowns.existingOrProposed.length; ++i ) {
        if ( this.filtersDropdowns.existingOrProposed[i] == 'existing' ) this.selectParams.existingOrProposed.options.push( { value: 'existing', text: 'Existing' } );
        if ( this.filtersDropdowns.existingOrProposed[i] == 'proposed' ) this.selectParams.existingOrProposed.options.push( { value: 'proposed', text: 'Proposed' } );
      }
      for ( i = 0; i < this.filtersDropdowns.entity.length; ++i ) {
        if ( this.filtersDropdowns.entity[i] == 'bulb' ) this.selectParams.entity.options.push( { value: 'bulb', text: 'Lamp' } );
        if ( this.filtersDropdowns.entity[i] == 'fixture' ) this.selectParams.entity.options.push( { value: 'fixture', text: 'Fixture' } );
        if ( this.filtersDropdowns.entity[i] == 'housing' ) this.selectParams.entity.options.push( { value: 'housing', text: 'Housing' } );
        if ( this.filtersDropdowns.entity[i] == 'accessory' ) this.selectParams.entity.options.push( { value: 'accessory', text: 'Accessory' } );
      }
      this.filtersDropdowns.existingOrProposed = _exProp;
      this.filtersDropdowns.entity = _ent;
      for ( i = 0; i < prData.length; ++i ) {
        this.productsActivities[prData[i].id] = false;
      }

      this.filtersDropdowns.productType.forEach( _pt => { this.selectParams.productType.options.push( { value: _pt, text: _pt } ); });
      this.filtersDropdowns.baseType.forEach( _bt => { this.selectParams.baseType.options.push( { value: _bt, text: _bt } ); });
      this.filtersDropdowns.manufacturer.forEach( _mn => { this.selectParams.manufacturer.options.push( { value: _mn.id, text: _mn.name } ); });

      if ( cb ) cb( );
    }, this.filters, false, this.paginationData, _withoutPreloader );
  }

  updateData ( withoutPreloader? ) {
    localStorage.setItem( 'filtersProductsList', JSON.stringify( this.filters ) );
    clearTimeout( this.filtersTimeout );
    this.filtersTimeout = setTimeout( ( ) => {
      this.paginationData.currentPage = 1;
      this.paginationData.offset = 0;
      if ( this.filters.entity == 'accessory' ) this.filters.baseType = '';
      if ( withoutPreloader ) this.loadData( undefined, true );
      else this.loadData( );
    }, 250 );
    
  }

  clearFilters ( ) {
    
    this.filters = {
      existingOrProposed: 'proposed',
      entity: '',
      manufacturer: '',
      productType: '',
      baseType: '',
      SKU: '',
      description: ''
    };

    this.updateData( );
    this.selectAllCH = false;
    this.changeSelectAll( );
  }

  _scrollIntoView ( ) {
    // Code to scroll window
    setTimeout( ( ) => {
      this.winRef.nativeWindow.scrollTo( 0, this._scrollTop );
    }, 1500 );
  }

  successCallback ( message ) {
    let data = {
      type: 'success',
      title: 'Success',
      html: message || '',
      showConfirmButton: false
    }
    this.loadData( );
    this.global.successMessage( data );
    setTimeout( ( ) => { swal.close( ); }, 1500 );
  }

  errorCallback ( message?: string, title?: string ) {
    let data = {
      type: 'error',
      title: title || '',
      html: message || 'We got some error here...'
    }
    this.global.errorMessage( data );
    // setTimeout( ( ) => { swal.close( ); }, 3000 );
  }

  makeInactive ( ) {
    let _ids = this.getProductIds();

    let data = {
      message: "Are you sure you want to permanently delete selected products?",
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    };

    this.global.confirmMessage( data, ( ) => {    
      this.model.makeProductsInactive( _ids, ( response ) => {
        if ( response.answer ) {
          if ( response.answer == 'success' ) {
            this.successCallback( 'Products has been deleted successfully!' );
            this.isChangeActivityButtonDisabled = true;
          }
          else if ( response.error ) this.errorCallback( response.error );
          else this.errorCallback( );
        }
      });
    });
    
  }

  checkActivityEquals ( ) {
    this.isChangeActivityButtonDisabled = true;
    for ( let _id in this.productsActivities ) {
      if ( this.productsActivities[_id] == true ) {
        this.isChangeActivityButtonDisabled = false;
        break;
      }
    }
  }


  onScrollDocument ( event ) {

    clearTimeout( this._scrollTopTimer );
    this._scrollTopTimer = setTimeout( ( ) => {
      if ( this._scrollSystemInit || this._scrollTop != 0 ) {
        localStorage.setItem( 'scrollProductsList', this.winRef.nativeWindow.scrollY );
      } else {
        this._scrollSystemInit = true;
      }
    }, 350);

  }

  uploadCSV ( $event, field ) {

    let inputValue = $event.target;
    this.changeinputUploadCSV( inputValue, field );
  }

  uploadSpecs ( $event, field ) {

    let inputValue = $event.target;
    this.changeInputSpecs( inputValue, field );
  }

  linkSpec ( $event, field ) {

    let inputValue = $event.target;
    this.changeInputLinkSpec( inputValue, field );
  }

  linkProductImage( $event, field ) {
    let inputValue = $event.target;
    this.changeInputLinkProductImage( inputValue, field );
  }

  changeinputUploadCSV ( inputValue: any, field ) {
    this.global.showPreloader( );
    let reader_offset = 0;    //current reader offset position
    let pending_content = '';

    let file: File = inputValue.files[0];
    let reader: FileReader = new FileReader( );
    let errorCB: string = '';
    let i: number = 0;

    reader.onloadend = ( evt:any ) => {

      field.value = '';

      //check for end of file
      if( evt.loaded == 0 ) return;

      //increse offset value
      reader_offset += evt.loaded;
      //check for only complete line
      let last_line_end = evt.target.result.lastIndexOf( '\n' );
      let content = pending_content + evt.target.result.substring( 0, last_line_end );

      pending_content = evt.target.result.substring( last_line_end+1, evt.target.result.length );
      //upload data
      this.model.sendProductsCSV( content, ( result ) => {

        this.global.hidePreloader( );
        if ( result.answer ) {
          if ( result.answer == 'success' ) this.successCallback( 'The operation completed successfully' );
          else if ( result.answer instanceof Array ) {
            for ( i = 0; i < result.answer.length; ++i ) {
              errorCB += result.answer[i] + '<br />';
            }
            this.errorCallback( errorCB, 'Not processed' );
          } else {
            this.errorCallback( );
          }
        }
      });
    };

    let blob = file.slice( reader_offset, reader_offset + file.size + 10 );
    reader.readAsText( blob );
  }

  changeInputSpecs ( inputValue: any, field ) {

    let formData = new FormData( );
    if( inputValue.files.length > 10 ) {
      this.global.defaultErrorCallback( 'Maximum 10 files allowed' );
    }
    else {
      this.global.showPreloader();
      for (let i = 0; i < inputValue.files.length; i++) {
        let file: File = inputValue.files[i];
        formData.append( 'pdf[' + i + ']', file );
      }

      this.model.uploadMultipleSpecs( formData, ( response ) => {
        this.global.hidePreloader( );
        if ( !response.error ) {
          this.successCallback( 'Product Specs were successfully loaded into the database' );
        }
        else this.global.defaultErrorCallback( response.error );
      });
    }
  }

  changeInputLinkSpec ( inputValue: any, field ) {

    let formData = new FormData( );
    this.global.showPreloader();
    let file: File = inputValue.files[0];
    formData.append( 'pdf', file );

    let _ids = this.getProductIds();

    formData.append( 'ids', _ids.join() );

    this.model.uploadLinkSpec( formData, ( response ) => {
      this.global.hidePreloader( );
      if ( !response.error ) {
        this.successCallback( 'Product Spec was successfully linked to products' );
      }
      else this.global.defaultErrorCallback( response.error );
    });
  }

  changeInputLinkProductImage( $event, linkImage ) {

    this.cropper.changeImageHandler( $event, '#image-preview', linkImage, true, ( image_link ) => {

      let _ids = this.getProductIds();

      this.model.linkImageToProducts( image_link, _ids, ( response ) => {

        this.global.hidePreloader( );
        $("#linkProductImage").val("");
        if ( !response.error ) {
          this.successCallback( 'Product image was successfully linked to products' );
        }
        else this.global.defaultErrorCallback( response.error );
      });
    } );
  }

  getProductIds() {
      let _ids = [];
      for ( let _id in this.productsActivities ) {
          if ( this.productsActivities[_id] == true ) _ids.push( _id );
      }
      return _ids;
  }

  createExistingForProposed ( ) {

    this.model.createExistingProductsForProposed( ( ) => {
      this.successCallback( 'Existing products has been created successfully' );
    });
  }



  openCloneProductPopup ( event, id, SKU, existingOrProposed ) {
    event.preventDefault( );

    if( existingOrProposed == 'proposed' ) {
      if ( !SKU || SKU === '' ) {
        this.errorCallback( 'Product you are trying to clone does not have SKU and can not be cloned. Please enter SKU for the product and try again' );
        return;
      }
    }
    this.cloneProductPopupVisible = true;
    this.cloneProductID = id;
    this.fixingBodyOverflow( );
  }

  onCloseClonePopup ( ) {
    this.cloneProductPopupVisible = false;
    this.fixingBodyOverflow( );
  }


  minimizePopup ( ) { 
    this.popupMinimized = !this.popupMinimized; 
    this.fixingBodyOverflow( );
  }
  
  fixingBodyOverflow ( ) {
    this.global.fixBodyOverflow( this.cloneProductPopupVisible && this.popupMinimized == false );
  }

  onSubmitClonePopup ( $eventData ) {

    if ( $eventData.responseType == 'hasDuplicate' ) {
      this.errorCallback( 'Unable to clone. Please make sure all SKUs you are submitting are unique' );
    }
    
    if ( $eventData.responseType == 'exists' ) {
      this.errorCallback( 'Product with SKU "' + $eventData.responseData + '" already exists!' );
    }
    
    if ( $eventData.responseType == 'success' ) {
      this.cloneProductPopupVisible = false;
      this.fixingBodyOverflow( );
      this.successCallback ( 'Product has been cloned successfully!' )
    }

  }

  changeSelectAll ( ) {
    if ( this.selectAllCH ) {
      for ( let i = 0; i < this.productsData.length; ++i ) {
        this.productsActivities[this.productsData[i].id] = true;
      }
    } else {
      for ( let i = 0; i < this.productsData.length; ++i ) {
        this.productsActivities[this.productsData[i].id] = false;
      }
    }
    this.checkActivityEquals( );
  }

  changeAcceptCloneProduct ( ) {
    localStorage.setItem('acceptCloneProduct', ''+this.acceptCloneProduct);
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/products/products/products.component.ts